<div class="chips-list-container">
  <ng-container *ngFor="let column of objectKeys(chipsList)">
    <core-chip
      *ngFor="let value of chipsList[column]"
      variant="closeable"
      [label]="value"
      diameter="40px"
      (closed)="removeFilter(column, value, $event)"
    ></core-chip>
  </ng-container>
</div>
